import { render } from "./WorkType.vue?vue&type=template&id=ad344794"
import script from "./WorkType.vue?vue&type=script&lang=ts"
export * from "./WorkType.vue?vue&type=script&lang=ts"
script.render = render

export default script